import * as React from 'react';
import {
  Box,
  Container,
  Typography,
  useTheme,
  useMediaQuery,
} from '@mui/material';

const Footer: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        py: { xs: 2, md: 4 },
        borderTop: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
        position: 'relative',
        zIndex: 1,
      }}
    >
      <Container maxWidth="lg">
        {/* <Grid container spacing={4}>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <Box sx={{ mb: 4 }}>
              <Box 
                component="img" 
                src={logo} 
                alt="ClassAct Logo" 
                sx={{ height: 40, mb: 2 }} 
              />
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                ClassAct connects individuals to class action lawsuits, streamlining enrollment and ensuring eligible users receive the compensation they deserve.
              </Typography>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <IconButton 
                  color="primary" 
                  href="https://www.instagram.com/classactapp" 
                  target="_blank"
                  size="small"
                  sx={{ 
                    bgcolor: 'action.hover',
                  }}
                >
                  <InstagramIcon fontSize="small" />
                </IconButton>
                <IconButton 
                  color="primary" 
                  href="mailto:info@classact.com" 
                  size="small"
                  sx={{ 
                    bgcolor: 'action.hover',
                  }}
                >
                  <EmailIcon fontSize="small" />
                </IconButton>
              </Box>
            </Box>
          </Grid>
          <Grid size={{ xs: 6, sm: 6, md: 3 }}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              Company
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link href="#" color="text.secondary" underline="hover">About Us</Link>
              <Link href="#" color="text.secondary" underline="hover">Our Team</Link>
            </Box>
          </Grid>

          <Grid size={{ xs: 6, sm: 6, md: 3 }}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              Resources
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link href="#" color="text.secondary" underline="hover">For Plaintiffs</Link>
              <Link href="#" color="text.secondary" underline="hover">For Law Firms</Link>
            </Box>
          </Grid>

          <Grid size={{ xs: 6, sm: 6, md: 3 }}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              Legal
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link href="#" color="text.secondary" underline="hover">Terms of Service</Link>
              <Link href="#" color="text.secondary" underline="hover">Privacy Policy</Link>
              <Link href="#" color="text.secondary" underline="hover">Cookie Policy</Link>
              <Link href="#" color="text.secondary" underline="hover">Disclaimer</Link>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4 }} /> */}

        <Box
          sx={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: 'center',
            alignItems: isMobile ? 'center' : 'flex-start',
            gap: 2,
          }}
        >
          <Typography
            variant="body2"
            color="text.secondary"
            align={isMobile ? 'center' : 'left'}
          >
            © {currentYear} ClassAct Technologies, Inc. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
